// src/pages/providers/2_dashboard/components/PatientRestoreDialog.js
import React from 'react';
import * as AlertDialog from '@radix-ui/react-alert-dialog';
import { ReplyIcon } from '@heroicons/react/outline';

function PatientRestoreDialog({ isOpen, onClose, patient, onConfirm, isRestoring }) {
  return (
    <AlertDialog.Root
      open={isOpen}
      // Accessibility/UX: only run the close callback when the dialog is actually closing.
      // This prevents accidental closes (and loss of typed input) during unrelated re-renders.
      onOpenChange={(open) => { if (!open) onClose(); }}
    >
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="radix-dialog-overlay-motion fixed inset-0 bg-black/40 backdrop-blur-sm" />
        <AlertDialog.Content className="radix-dialog-content-centered-motion fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg shadow-lg p-6 max-w-md w-[90vw] max-h-[85vh] overflow-auto">
          <AlertDialog.Title className="text-xl font-semibold text-gray-900 flex items-center">
            <ReplyIcon className="w-6 h-6 text-green-600 mr-2" />
            Restore Patient
          </AlertDialog.Title>

          <AlertDialog.Description asChild>
            <div className="mt-3 text-sm text-gray-700">
              <p className="mb-2">
                You are about to restore the following patient to the 'Current Patients' table:
              </p>

              <p className="font-medium text-gray-900 mb-4">
                {patient?.firstName} {patient?.lastName} ({patient?.email})
              </p>

              <div className="bg-green-50 rounded-lg p-4 mb-4">
                <p className="text-sm text-green-700">
                  All patient information will be retained and accessible. The patient can be archived again if necessary.
                </p>
              </div>
            </div>
          </AlertDialog.Description>

          <div className="mt-6 flex justify-end gap-3">
            <AlertDialog.Cancel asChild>
              <button
                className="px-4 py-2 text-sm font-semibold text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500"
                disabled={isRestoring}
              >
                Cancel
              </button>
            </AlertDialog.Cancel>

            <button
              onClick={onConfirm}
              disabled={isRestoring}
              className={`px-4 py-2 text-sm font-semibold text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 ${
                isRestoring
                  ? 'bg-green-300 cursor-not-allowed'
                  : 'bg-green-600 hover:bg-green-700 focus:ring-green-500'
              }`}
            >
              {isRestoring ? (
                <span className="flex items-center">
                  <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Restoring...
                </span>
              ) : (
                'Restore'
              )}
            </button>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
}

export default PatientRestoreDialog;

